import React from 'react';

import './ComponentPicker.css'
import './CommonPickerStyle.css'

import DragableComponentInList from './DragableComponentInList'
import DnDContext from '../../DnDContext';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getIcon } from '../../GetMaterialIcon'
import { DnD_element_type_menu, DnD_element_type_category } from '../../common/ConstantValues';

const ComponentPicker = () => {
  const NORMAL_prefix = "NORMAL"
  const SPECIAL_prefix = "SPECIAL"

  return (
    <div class="picker-style component-picker">
      <p class="list-title"> 일반 </p>
      <ul class="component-list">
        <DragableComponentInListWrap title="텍스트" type={DnD_element_type_menu.COMPONENT.NORMAL.TEXT} prefix_type={NORMAL_prefix} icon={getIcon("text_fields")} cat_type={DnD_element_type_category.MENU} />
        <DragableComponentInListWrap title="버튼" type={DnD_element_type_menu.COMPONENT.NORMAL.BUTTON} prefix_type={NORMAL_prefix} icon={getIcon("crop_5_4")} cat_type={DnD_element_type_category.MENU} />
        <DragableComponentInListWrap title="이미지" type={DnD_element_type_menu.COMPONENT.NORMAL.IMAGE} prefix_type={NORMAL_prefix} icon={getIcon("image")} cat_type={DnD_element_type_category.MENU} />
        <DragableComponentInListWrap title="그룹" type={DnD_element_type_menu.COMPONENT.NORMAL.GROUP} prefix_type={NORMAL_prefix} icon={getIcon("add_to_photos")} cat_type={DnD_element_type_category.MENU} />
      </ul>
      <p class="list-title"> 특수 </p>
      <ul class="component-list">
        <DragableComponentInListWrap title="전화번호" type={DnD_element_type_menu.COMPONENT.SPECIAL.TEL} prefix_type={SPECIAL_prefix} icon={getIcon("contact_phone")} cat_type={DnD_element_type_category.MENU} />
        <DragableComponentInListWrap title="주소" type={DnD_element_type_menu.COMPONENT.SPECIAL.ADDR} prefix_type={SPECIAL_prefix} icon={getIcon("home_work")} cat_type={DnD_element_type_category.MENU} />
        <DragableComponentInListWrap title="날짜" type={DnD_element_type_menu.COMPONENT.SPECIAL.DATE} prefix_type={SPECIAL_prefix} icon={getIcon("insert_invitation")} cat_type={DnD_element_type_category.MENU} />
      </ul>
    </div>  
  )
}

const DragableComponentInListWrap = (props) => {
  return (
    <DnDContext>
      <DragableComponentInList {...props}/>
    </DnDContext>
  )
}

export default ComponentPicker